import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const FilterControls = ({ 
  searchQuery, 
  onSearchChange, 
  statusFilter, 
  onStatusChange,
  sortBy,
  onSortChange,
  totalItems,
  filteredCount
}) => {
  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'perfect', label: 'Perfect' },
    { value: 'damaged', label: 'Damaged' }
  ];

  const sortOptions = [
    { value: 'newest', label: 'Newest First' },
    { value: 'oldest', label: 'Oldest First' },
    { value: 'name-asc', label: 'Name (A-Z)' },
    { value: 'name-desc', label: 'Name (Z-A)' }
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-4 mb-6 elevation-1">
      <div className="flex flex-col lg:flex-row gap-4">
        <div className="flex-1">
          <Input
            type="search"
            placeholder="Search by name or LIIN..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
          />
        </div>

        <div className="flex flex-col sm:flex-row gap-4 lg:w-auto">
          <div className="w-full sm:w-48">
            <Select
              options={statusOptions}
              value={statusFilter}
              onChange={onStatusChange}
              placeholder="Filter by status"
            />
          </div>

          <div className="w-full sm:w-48">
            <Select
              options={sortOptions}
              value={sortBy}
              onChange={onSortChange}
              placeholder="Sort by"
            />
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between mt-4 pt-4 border-t border-border">
        <div className="flex items-center gap-2">
          <Icon name="Package" size={18} color="var(--color-primary)" />
          <span className="text-sm text-muted-foreground">
            Showing <span className="font-semibold text-foreground">{filteredCount}</span> of <span className="font-semibold text-foreground">{totalItems}</span> items
          </span>
        </div>

        {searchQuery && (
          <button
            onClick={() => onSearchChange('')}
            className="text-sm text-primary hover:text-primary/80 transition-smooth flex items-center gap-1"
          >
            <Icon name="X" size={16} />
            <span>Clear search</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default FilterControls;